(function(Cobalt, undefined) {
    Cobalt.Routes = function () {
        Cobalt.Routes.Instance = this;
        this.buildRoute = function(url, routeValues) {
            return url + Cobalt.Utils.objectToQueryString(routeValues);
        };
    };
})(Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Routes.js